import { createFetcher } from '../contexts/Fetcher';
import { useCallback, useContext } from 'react';
import { apiOverview, ISummaryLatest } from '../resources/api/apiOverview';
import { ActiveProductContext } from '../contexts/ActiveProductContext';

const { useGetProductSummaryLatest } = apiOverview;

export const ProductSummaryFetcher = createFetcher(() => {
  const product = useContext(ActiveProductContext);
  const { execute } = useGetProductSummaryLatest(product?.id);

  return useCallback(async () => {
    try {
      return await execute();
    } catch (e) {
      if ((e as any)?.response?.status === 404) {
        return {
          version: null,
          installer: [],
        } as ISummaryLatest;
      }
      throw e;
    }
  }, [execute]);
});
